type Guid = string;

export interface ClientInfo {
    Sender?: SenderInfo;
    Recipient?: RecipientInfo;
    CurrentAccount?: AccountInfo;
}

export interface RecipientInfo {
    IfnsCode?: string;
    MriCode?: string;
    TogsCode?: string;
    UpfrCode?: string;
    PrototypeUpfrCode?: string;
}

export interface SenderInfo {
    Type?: AccountType;
    Inn?: string;
    Kpp?: string;
    FullName?: string;
    Signer?: SignerInfo;
}

export interface SignerInfo {
    Type: SignerType;
    Certificate: CertificateInfo;
}

export interface CertificateInfo {
    Inn?: string;
    Fio?: Fio;
    Ogrn?: string;
    OgrnIp?: string;
    OrgName?: string;
    RnsFss?: string;
    Region?: string;
}

export interface Fio {
    Surname?: string;
    Name?: string;
    Patronymic?: string;
}

export enum AccountType {
    Organization = 1,
    Individual = 2,
    ForeignOrganization = 3,
    CreditOrganization = 4,
}

export enum SignerType {
    Unknown = 0,
    Chief = 1,
    Representative = 2,
}

export interface AccountInfo {
    Type?: AccountType;
    Inn?: string;
    FullName?: string;
    ShortName?: string;
    Ogrn?: string;
    Okato?: string;
    Oktmo?: string;
    Okved?: string;
    Okpo?: string;
    Chief?: EmployeeInfo;
    Phone?: string;
    AddressRegistration?: Address;
    AddressActual?: Address;
    Pfr?: PfrInfo;
    Fss?: FssInfo;
    Fns?: FnsInfo;
    Oms?: OmsInfo;
    Organization?: OrganizationInfo;
    Individual?: IndividualInfo;
}

export interface EmployeeInfo {
    Inn?: string;
    Fio?: Fio;
    Position?: string;
    Phone?: string;
    Email?: string;
    BirthDate?: string;
    BirthPlace?: string;
    Gender?: Gender;
    CitizenshipCode?: string;
    Passport?: PassportInfo;
    AddressRegistration?: Address;
    AddressForeign?: AddressForeign;
}

export enum Gender {
    Unknown = 0,
    Male = 1,
    Female = 2,
}

export interface PassportInfo {
    Code?: string;
    SeriesNumber?: string;
    IssuedDate?: string;
    IssuedBy?: string;
}

export interface AddressForeign {
    Country?: string;
    CountryCode?: string;
    Index?: string;
    Address?: string;
}

export interface Address {
    Country?: string;
    Index?: string;
    Region?: AddressItem;
    District?: AddressItem;
    City?: AddressItem;
    Settlement?: AddressItem;
    Street?: AddressItem;
    HouseRange?: AddressItem;
    House?: string;
    Building?: string;
    Flat?: string;
}

export interface AddressItem {
    Code?: string;
    FiasCode?: Guid;
    Name?: string;
    Abbreviation?: string;
}

export interface IndividualInfo {
    PolicyNumber?: string;
    Status?: IndividualStatus;
}

export enum IndividualStatus {
    Unknown = 0,
    Resident = 1,
    NonResident = 2,
}

export interface OrganizationInfo {
    Kpp?: string;
    KppObject?: string;
    KppAnother?: string;
    Okopf?: string;
    Okfs?: string;
    Bookkeeper?: EmployeeInfo;
    SeparateDepartment?: SeparateDepartmentInfo;
    CreditOrganization?: CreditOrganizationInfo;
    ForeignOrganization?: ForeignOrganizationInfo;
}

export interface SeparateDepartmentInfo {
    Kpp?: string;
    FullName?: string;
    DepartmentCode?: string;
    Phone?: string;
    AddressSD?: Address;
}

export interface CreditOrganizationInfo {
    RegistrationNumber?: string;
    Bik?: string;
}

export interface ForeignOrganizationInfo {
    AddressForeign?: AddressForeign;
}

export interface PfrInfo {
    CategoryCode?: string;
    RegistrationNumber?: string;
    RegistrationNumberIp?: string;
}

export interface FssInfo {
    RegistrationNumber?: string;
    AdditionalCode?: string;
    DependencyCode?: string;
    Representative?: EmployeeInfo;
}

export interface FnsInfo {
    Representative?: EmployeeInfo;
    RepresentativeDocument?: RepresentativeDocumentInfo;
}

export interface OmsInfo {
    Tfoms?: string;
}

export interface RepresentativeDocumentInfo {
    Name?: string;
}
